module.exports = __webpack_public_path__ + "static/media/eminence-asakusa-7.0b23147b.jpg";